import { useCallback } from 'react';
import dayjs from 'dayjs';

import { useCopyToClipboard } from '../hooks/useCopyToClipboard';
import { ISubmitPaymentLinkOneTimePayment } from '../types/types';

const COPY_MESSAGES = {
  success: 'Linha digitável copiada!',
  empty: 'Linha digitável não disponível',
  error: 'Erro ao copiar linha digitável',
};

export const useModalPaymentLinkBoletoBootstrap = (
  data?: ISubmitPaymentLinkOneTimePayment,
) => {
  const { copied, copy } = useCopyToClipboard(COPY_MESSAGES);

  const line = data?.line;
  const boletoLink = data?.url || data?.pdf;

  const handleCopyLine = useCallback(() => copy(line), [copy, line]);

  const handleOpenBoleto = useCallback(() => {
    if (boletoLink) {
      window.open(boletoLink, '_blank', 'noopener,noreferrer');
    }
  }, [boletoLink]);

  const dueAtLabel = data?.dueAt
    ? dayjs(data.dueAt).format('DD/MM/YYYY')
    : undefined;

  return {
    copied,
    line,
    handleCopyLine,
    canCopy: Boolean(line),
    handleOpenBoleto,
    canOpenBoleto: Boolean(boletoLink),
    dueAtLabel,
  };
};

export default useModalPaymentLinkBoletoBootstrap;
